import { render } from "./WizardSetup.vue?vue&type=template&id=7e058586&scoped=true"
import script from "./WizardSetup.vue?vue&type=script&lang=js"
export * from "./WizardSetup.vue?vue&type=script&lang=js"

import "./WizardSetup.vue?vue&type=style&index=0&id=7e058586&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e058586"]])

export default __exports__